<template>
    <page>
        <module enable-flex>
            <view-list ref="view" :work-type="30">
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="背贴码">
                            <m-code-batch-input name="produce_codes" field-name="背贴码"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="IMEI">
                            <m-code-batch-input name="imeis" field-name="IMEI"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="商户">
                            <c-select name="merchant_id" async @search="searchMerchant"></c-select>
                        </m-search-item>
                        <m-search-item label="商户名称">
                            <c-input name="merchant_name" placeholder="支持模糊查询"></c-input>
                        </m-search-item>
                        <m-search-item label="单号">
                            <c-input name="keyword" placeholder="售后单号/关联订单号"></c-input>
                        </m-search-item>
                        <m-search-item label="售后类型">
                            <c-select name="after_sale_type" :options="SALE_AFTER_SALE_TYPE"></c-select>
                        </m-search-item>
                        <m-search-item label="申请人/手机">
                            <c-input name="applicant"></c-input>
                        </m-search-item>
                        <m-search-item label="寄回快递">
                            <c-input name="return_express"></c-input>
                        </m-search-item>
                        <m-search-item label="申请时间" colspan="2">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <c-table-column type="button" label="操作" width="80" fixed="right">
                    <template #default="{data}">
                        <c-table-button icon="tf-detail" @click="$refs.detail.open(data)">详情</c-table-button>
                    </template>
                </c-table-column>

                <template #after_sale_no="{data}">
                    <div class="m-product-info">
                        <p>{{data.after_sale_no || '-'}}</p>
                        <p v-if="data.after_sale_apply_no" class="m-product-info-code">售后申请单号：{{data.after_sale_apply_no}}</p>
                    </div>
                </template>

                <template #saas_info="{data}">
                    <div class="m-saas-info">
                        <p>{{data.saas_id || '-'}}</p>
                        <p class="m-saas-info-name">{{data.saas_name || '-'}}</p>
                    </div>
                </template>

                <template #product_info="{data}">
                    <m-product-info :name="getProductText(data)" :level="data.level_type" :code="data.produce_code" :imei="data.produce_imei"></m-product-info>
                </template>

                <template #refund_info="{data}">
                    <span v-if="!Number(data.refund_amount)">-</span>
                    <div v-else class="m-product-info">
                        <p style="color: #e53e3e;">{{formatPrice(data.refund_amount)}}</p>
                        <p class="m-product-info-code">{{data.refund_date || '-'}}</p>
                    </div>
                </template>

                <template #produce_code="{data}">
                    {{data.produce_code}} <c-link v-if="data.produce_code" color="gray" @click="$copy(data.produce_code)"><i class="tf">&#xe6b0;</i></c-link>
                </template>

                <template #after_sale_type="{data}">
                    <c-state async dict="SALE_AFTER_SALE_TYPE" tag :value="data.after_sale_type"></c-state>
                </template>

                <template #after_sale_state="{data}">
                    <c-state async dict="SALE_AFTER_SALE_STATE" tag :value="data.after_sale_state"></c-state>
                </template>

                <template #sale_price="{data}">
                    {{formatPrice(data.sale_price)}}
                </template>

                <template #after_sale_amount="{data}">
                    <span style="color: #e53e3e;">{{formatPrice(data.after_sale_amount)}}</span>
                </template>

                <template #audit_user_id="{data}">
                    {{data.audit_user_realname || '-'}}
                </template>
            </view-list>
            <erp-offline-aftersale-detail ref="detail"></erp-offline-aftersale-detail>
        </module>
    </page>
</template>

<script>
import ErpOfflineAftersaleDetail from './components/offline_aftersale_detail.vue';
import {asyncMapState} from '@/store';

export default {
    name: 'erp_offline_aftersales_order',
    components: {ErpOfflineAftersaleDetail},
    computed: {
        ...asyncMapState(['SALE_AFTER_SALE_TYPE'])
    },
    methods: {
        searchMerchant(keyword, resolve) {
            this.request({url: '/sys_saas/options', data: {keyword}, success: resolve});
        },
        formatPrice(price) {
            if (price === null || price === undefined || price === '') return '-';
            return '¥' + parseFloat(price).toFixed(2);
        },
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.model_name) parts.push(data.model_name);
            if (data.memory_name) parts.push(data.memory_name);
            if (data.color_name) parts.push(data.color_name);
            return parts.join(' ') || '-';
        }
    }
};
</script>

<style scoped>
.m-product-info {line-height: 24px; font-size: 13px; color: #333;}
.m-product-info p {margin: 0;}
.m-product-info-code {color: #999; font-size: 12px;}
.m-saas-info {line-height: 20px; font-size: 13px; color: #333;}
.m-saas-info p {margin: 0;}
.m-saas-info-name {color: #999; font-size: 12px;}
</style>
